import React from 'react'
import PartDetail from '../PureComponent/PartDetail'

const RenderPartsDetail = () => {
  return (
  <PartDetail/>
  )
}

export default RenderPartsDetail